import { PaymentMethodType } from '../../models/paymentMethods/enums';
import { getIsFreeEvent } from '../../selectors/event';
import { getAvailablePaymentMethods } from '../../selectors/payment';
import { CheckoutState } from '../../state';

const FPP_PAYMENT_METHODS = [
    PaymentMethodType.FPP_PAYPAL,
    PaymentMethodType.AUTHNET,
];

const isFPPEvent = (state: CheckoutState) =>
    getAvailablePaymentMethods(state).some((paymentMethod) =>
        FPP_PAYMENT_METHODS.includes(paymentMethod.type),
    );

export const isStripeConfirmationTokenPaymentMethodAvailable = (
    state: CheckoutState,
) => !getIsFreeEvent(state) && !isFPPEvent(state);
